import { getReq } from "./instance";

export const getGroup = async (groupId: string, params = {}) => {
  return getReq(`/Group/${groupId}`, params);
};
